import { controls,grouped } from "../controls";
const inddet = {
label: "Individual Details",
pageLabel: "Individual Details",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
formTabs:
 {allTabs: [
{ label: "General", uid: "general" },
{label: "Home Address",uid: "home_address",fastpath:"addresses"}
]},
filter:[
...controls.displayText({ tab: "filter", label: "Customer"}),
...controls.oc({ tab: "filter", c: "Customer", placeHolder: "Customer Code", name: "IndividualDetails-individual_customer-customer_code",fastpath: "customers"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "IndividualDetails-individual_customer-customer_display"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Title",star:false}),
...controls.autoComplete({tab: "general", name: "title_code", width: "col-sm-2",controlType: "Title"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Gender",star:false}),
...controls.autoComplete({tab: "general", name: "gender_code", width: "col-sm-2",controlType: "Gender"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "First Name",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "first_name",isRequired:true,maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Middle Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "middle_name",maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Last Name",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "last_name",isRequired:true,maxlength:50 ,isReadOnly:"edit" }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Mothers Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "mothers_name",maxlength:30,isRequired:true}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Fathers Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "fathers_name",maxlength:30}),
...controls.displayText({ tab: "general", label: ""}),
...controls.magicDateLabel({ tab: "general", label: "Date of birth",target: "dob",star:false}),
...controls.magicDate({ tab: "general", name: "dob", dateType: "ontype",maxDate:'session_date' }),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Age"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "age",maxlength:5}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Voterid",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "voterid",maxlength:30}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Passport",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "passport",maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Ration Card",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "ration_card",maxlength:14}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Drivers License",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "drivers_license",maxlength:14}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Marital Status",star:false}),
...controls.autoComplete({tab: "general", name: "marital_status_code", width: "col-sm-2",controlType: "MaritalStatus"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Blood Group",star:false}),
...controls.oc({ tab: "general", c: "BloodGroup", placeHolder: "Blood Group Code", name: "blood_group_code",fastpath: "blood_groups",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "blood_group_display"}),
...controls.displayText({ tab: "general", label: "Religion",star:false}),
...controls.autoComplete({tab: "general", name: "religion_code", width: "col-sm-2",controlType: "Religion"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Caste",star:false}),
...controls.oc({ tab: "general", c: "Caste", placeHolder: "Caste Code", name: "caste_code",fastpath: "castes",autoopen:true,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "caste_display"}),
...controls.displayText({ tab: "general", label: "Subcaste",star:false}),
...controls.oc({ tab: "general", c: "SubCaste", placeHolder: "Subcaste Code", name: "subcaste_code",fastpath: "subcastes",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "subcaste_display"}),
...controls.displayText({ tab: "general", label: "Occupation",star:true}),
...controls.oc({ tab: "general", c: "Occupation", placeHolder: "Occupation Code", name: "occupation_code",isRequired:true,fastpath: "occupations",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "occupation_display"}),
...controls.displayText({ tab: "general", label: "Income Group",star:false}),
...controls.autoComplete({tab: "general", name: "income_group_code", width: "col-sm-2",controlType: "IncomeGroup"}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Monthly Income"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "monthly_income",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Employer Details",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "employer_details",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Gas Connection",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "gas_connection",maxlength:30}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "home_address", label: "Line 1",star:false}),
...controls.text({ tab: "home_address",  placeHolder: "", name: "home_address.line_1",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "home_address", label: "Line 2",star:false}),
...controls.text({ tab: "home_address",  placeHolder: "", name: "home_address.line_2",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "home_address", label: "Line 3",star:false}),
...controls.text({ tab: "home_address",  placeHolder: "", name: "home_address.line_3",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "home_address", label: "Village",star:true}),
...controls.autoComplete({tab: "home_address", name: "home_address.village_code", width: "col-sm-2",controlType: "Village"}),
...controls.displayText({ tab: "home_address", label: ""}),
...controls.displayText({ tab: "home_address", label: "Taluka",star:true}),
...controls.autoComplete({tab: "home_address", name: "home_address.taluka_code", width: "col-sm-2",controlType: "Taluka"}),
...controls.displayText({ tab: "home_address", label: ""}),
...controls.displayText({ tab: "home_address", label: "District",star:true}),
...controls.oc({ tab: "home_address", c: "District", placeHolder: "District Code", name: "home_address.district_code",isRequired:true,fastpath: "districts",hidden:false}),
...controls.showData({ tab: "home_address", displaytype: "capital", data: "home_address.district_display"}),
...controls.displayText({ tab: "home_address", label: "State",star:true}),
...controls.oc({ tab: "home_address", c: "State", placeHolder: "State Code", name: "home_address.state_code",isRequired:true,fastpath: "states",hidden:false}),
...controls.showData({ tab: "home_address", displaytype: "capital", data: "home_address.state_display"}),
...controls.displayText({ tab: "home_address", label: "Country",star:true}),
...controls.oc({ tab: "home_address", c: "Country", placeHolder: "Country Code", name: "home_address.country_code",isRequired:true,fastpath: "countries",hidden:false}),
...controls.showData({ tab: "home_address", displaytype: "capital", data: "home_address.country_display"}),
...controls.displayText({ tab: "home_address", label: "Pincode",star:false}),
...controls.text({ tab: "home_address",  placeHolder: "", name: "home_address.pincode",maxlength:6}),
...controls.displayText({ tab: "home_address", label: ""}),
...controls.displayText({ tab: "home_address", label: "Latitude"}),
...controls.floatOnly({ tab: "home_address",  placeHolder: "", name: "home_address.latitude",maxlength:10}),
...controls.displayText({ tab: "home_address", label: ""}),
...controls.displayText({ tab: "home_address", label: "Longitude"}),
...controls.floatOnly({ tab: "home_address",  placeHolder: "", name: "home_address.longitude",maxlength:10}),
...controls.displayText({ tab: "home_address", label: ""}),
...controls.displayText({ tab: "home_address", label: "Short Name",star:false}),
...controls.text({ tab: "home_address",  placeHolder: "", name: "home_address.short_name",maxlength:50}),
...controls.displayText({ tab: "home_address", label: ""}),
]
,history:{
perPage: 10,
reportHeader: "Individual Details",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Title Id",accessor: "title_id",},
{Header: "First Name",accessor: "first_name",},
{Header: "Middle Name",accessor: "middle_name",},
{Header: "Last Name",accessor: "last_name",},
{Header: "Date of birth",accessor: "dob",type:'date'},
]}};
export default inddet;